// extracted by mini-css-extract-plugin
module.exports = {"btnClear":"InputClear_btnClear__19c1y"};